var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("门诊预约问诊管理")]),
            _c("el-breadcrumb-item", [_vm._v("专家就诊管理")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "demo-app" },
      [
        _c("div", { staticClass: "demo-app-sidebar" }, [
          _c("div", { staticClass: "demo-app-sidebar-section" }, [
            _c("h2", [
              _vm._v("预约列表 (" + _vm._s(_vm.currentEvents.length) + ")"),
            ]),
            _c(
              "ul",
              _vm._l(_vm.currentEvents, function (event) {
                return _c("li", { key: event.id, staticClass: "li-item" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.formatDate(event.start, "yyyy-MM-dd hh:mm"))
                    ),
                  ]),
                  _c("b", [_vm._v(" 至 ")]),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.formatDate(event.end, "yyyy-MM-dd hh:mm"))
                    ),
                  ]),
                  _c("i", [_vm._v(_vm._s(event.title))]),
                ])
              }),
              0
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "demo-app-main" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  remote: "",
                  "remote-method": _vm.remoteMethod,
                  placeholder: "请搜索并选择医生",
                },
                on: { change: _vm.onDoctorChange },
                model: {
                  value: _vm.doctorId,
                  callback: function ($$v) {
                    _vm.doctorId = $$v
                  },
                  expression: "doctorId",
                },
              },
              _vm._l(_vm.doctorList, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
            _c("FullCalendar", {
              ref: "fullCalendar",
              staticClass: "demo-app-calendar",
              staticStyle: { "margin-top": "20px" },
              attrs: { options: _vm.calendarOptions },
              scopedSlots: _vm._u([
                {
                  key: "eventContent",
                  fn: function (arg) {
                    return [
                      _c("b", [_vm._v(_vm._s(arg.timeText))]),
                      _c("i", [_vm._v(_vm._s(arg.event.title))]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              width: "70%",
              visible: _vm.dialogVisible,
              title: _vm.title,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              close: _vm.dialogClose,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: { model: _vm.dialogParams, "label-width": "120px" },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "就诊医院：", prop: "diagnosisLocationId" },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "请选择就诊医院",
                        },
                        model: {
                          value: _vm.diagnosisLocationId,
                          callback: function ($$v) {
                            _vm.diagnosisLocationId = $$v
                          },
                          expression: "diagnosisLocationId",
                        },
                      },
                      _vm._l(_vm.diagnosisList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._l(_vm.timeData, function (item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "预约时段：" } },
                        [
                          _c("el-time-select", {
                            attrs: {
                              placeholder: "起始时间",
                              "picker-options": {
                                start: "08:00",
                                step: "00:15",
                                end: "12:00",
                              },
                            },
                            model: {
                              value: item.startTimeLong,
                              callback: function ($$v) {
                                _vm.$set(item, "startTimeLong", $$v)
                              },
                              expression: "item.startTimeLong",
                            },
                          }),
                          _c("span", { staticStyle: { padding: "0 10px" } }, [
                            _vm._v("至"),
                          ]),
                          _c("el-time-select", {
                            attrs: {
                              placeholder: "结束时间",
                              "picker-options": {
                                start: "08:00",
                                step: "00:15",
                                end: "12:00",
                                minTime: item.startTimeLong,
                              },
                            },
                            model: {
                              value: item.endTimeLong,
                              callback: function ($$v) {
                                _vm.$set(item, "endTimeLong", $$v)
                              },
                              expression: "item.endTimeLong",
                            },
                          }),
                          item.startTimeLong && item.endTimeLong
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeTime(item.id, index)
                                    },
                                  },
                                },
                                [_vm._v("删除时段")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "可预约人数：" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0 },
                            model: {
                              value: item.canUserCount,
                              callback: function ($$v) {
                                _vm.$set(item, "canUserCount", $$v)
                              },
                              expression: "item.canUserCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "info" }, on: { click: _vm.addTime } },
                      [_vm._v("新增时段")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = false
                          },
                        },
                      },
                      [_vm._v("关闭")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isDisabled },
                        on: { click: _vm.setCalendar },
                      },
                      [_vm._v("确定")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }